export default __webpack_public_path__ + "static/media/img5.3737e656.PNG";